
export const translations = {
    fr: {
        common: {
            en: "English",
            ar: "العربية",
            fr: "Français",
            home: "Accueil",
            about: "A propos",
            services: "Services",
            packs: "Nos Packs",
            contact: "Contact",
            learnMore: "En savoir plus",
            send: "Envoyer",
            sending: "Envoi en cours...",
            success: "Email envoyé avec succès !",
            error: "Erreur lors de l'envoi de l'email.",
            fillFields: "Veuillez remplir tous les champs.",
            completeCaptcha: "Veuillez compléter le reCAPTCHA.",
            CRM:"24-CRM",
            Paie:"24-Paie",
            Gold:"24-Gold",
          
        },
        hero: {
            title: "Digitalisez votre entreprise avec confiance",
            subtitle: "Des solutions logicielles sur mesure pour optimiser vos processus métiers, développées par des experts qui comprennent vos enjeux B2B.",
            discover: "Découvrir nos solutions",
            contactUs: "Nous contacter",
            trust: "Plus de 2000 entreprises nous font confiance",
            features: ["Logiciels Sur Mesure", "Cloud Natif", "Support 6/7"]
        },
        expertise: {
            intro: "INTRODUCTION",
            aboutTitle: "À PROPOS DE POLYSOFT&CO",
            description: "Société Tunisienne basée à Sfax spécialisée dans le développement de solutions informatiques, issue du groupe familial opérant dans le secteur informatique depuis 1988. Nous croyons que chacun de nos produits doit évoluer et s'adapter aux besoins du marché afin de garantir une meilleure satisfaction client. Toujours soucieux de garantir le meilleur, nos efforts ne cesseront jamais d'évoluer grâce à un processus de développement technique et commercial complet et sur mesure.",
            stats: {
                clients: "Nos clients",
                experts: "Collaborateurs et experts métier",
                experience: "Ans d'expérience",
                solutions: "Solutions",
              
            }  ,
            performance: "La performance au service de votre croissance",
            NOTRE:"NOTRE IMPACT",
            Ready: "Solutions prêtes pour le Cloud v2.4",
            ECOSYSTÈME :"ECOSYSTÈME POLYSOFT&CO"

        },
        services: {
            title: "NOS SERVICES",
            subtitle: "DÉCOUVREZ NOS SOLUTIONS",
            crm_desc: "Notre nouvelle plateforme cloud de gestion commerciale et de gestion des commerciaux. Gérez : Votre stock, Vos clients, Vos fournisseurs, Votre banque et vos représentants commerciaux.",
            paie_desc: "Le logiciel 24-Paie vous offre beaucoup plus que les fonctions essentielles de la paie. Etablissez une paie complète pour vos employés avec un logiciel adaptable à tous les contrats.",
            gold_desc: "Logiciel de gestion de bijouterie gros spécialisé pour les diamantaires et orfèvres.",
            dev_desc: "Développement sur mesure pour vos projets desktop, web et Mobile (Android, iOS) avec les technologies les plus modernes.",
            consulting_desc: "Consulting IT et accompagnement digital de vos entreprises vers la transformation numérique.",
            fasty_desc: "Site E-commerce et Gestion commerciale Synchronisé pour une expérience omnicanale.",
            pointage_desc:"PolyPointage est une solution de gestion de présence et de suivi du temps de travail conçue pour calculer automatiquement les heures travaillées, absences, retards et congé. Elle intègre  aussi la gestion de présence par projet et génère des rapports détaillés pour faciliter la préparation de la paie.",
            GenRS_desc:"Ce module permet la génération de la retenue à la source en produisant automatiquement un fichier XML conforme aux normes, prêt à être déposé. Il garantit que toutes les informations nécessaires sont correctement formatées, facilitant ainsi la transmission sécurisée et fiable des données fiscales. ",
            Gestion_Cloud: "Gestion Commerciale Cloud",
            Gestion_Paie: "Gestion des ressources humaines et paie",
            Bijouterie: "Logiciel de gestion de bijouterie",
            Sur_Mesure: "Développement de logiciels sur mesure",
            Transformation: "Audit et transformation digitale",
            GenRS: "Génération retenue à la source (indépendant / synchronisé)",
            fasty: "E-commerce synchronisé",
            Exploration:"Exploration Solution ",
            PolyPointage:" Logiciel de pointage et gestion de présence",
            more: "Voir plus",
            less: "Voir moins",
            CRM:"24-CRM",
            Paie:"24-Paie",
            Gold:"24-Gold",

          
        },
        packs: {
            title: "NOS OFFRES",
            subtitle: "NOS PACKS & MODULES",
            startup: "PACK STARTUP",
            growth: "PACK GROWTH",
            pro: "PACK PRO",
            commercial: "MODULE COMMERCIAL",
            desktop: "VERSION DESKTOP",
            web: "SITE WEB",
            features: {
                startup: [
                    "Version mono magasin 1 utilisateur",
                    "Gestion de stock mono magasin",
                    "Gestion des clients",
                    "Gestion des fournisseurs",
                    "Gestion de la trésorerie"
                ],
                growth: [
                    "Version multi-depôts 3 utilisateurs",
                    "Gestion de stock multi-depôts",
                    "Bons de transfert",
                    "Gestion des clients",
                    "Gestion des fournisseurs",
                    "Gestion de la trésorerie"
                ],
                pro: [
                    "Version synchronisée web/desktop",
                    "Gestion des clients / Fournisseurs",
                    "Gestion Mono-Stock / Multi-Stocks",
                    "Gestion des inventaires",
                    "Gestion de la caisse",
                    "Modules paramétrables selon secteur"
                ]
            }
        },
        contact: {
            title: "CONTACTEZ-NOUS",
            subtitle: "C'est l'endroit idéal",
            tel_title: "Téléphone",
            address_title: "Adresse",
            address_val: "Rte de Teniour Km 1,5 / Sfax, Tunisia, 3000",
            form: {
                name: "Nom et prénom",
                tel: "N°Tel",
                address: "Adresse",
                email: "Email",
                software: "Sélectionnez un logiciel",
                message: "Message",
                submit: "Envoyer",
            },
            phone: "LIGNE DIRECTE",
            support: "MAIL SUPPORT",
            address: "SIÈGE SOCIAL",
            tel:"+216 74 433 020"
            // tel:"+216",
            // tell:"74",
            // telll:"20",
            // tellll:"433",
            // telllll:"020"
        },
        aboutPage: {
            subtitle: "C'est l'endroit idéal",
            title: "À propos de notre société",
        },
        values: {
            intro: "Pourquoi nous choisir ?",
            title: "NOS VALEURS",
            vision: {
                title: "Notre vision",
                desc: "D'être un leader du secteur sur le marché local, nos ambitions dépassent les frontières nous visons à s'internationaliser avec des partenaires ciblés."
            },
            mission: {
                title: "Notre mission",
                desc: "Notre mission est de créer des solutions de gestion performantes et innovantes pour les PME et les accompagner dans leur process de digitalisation. Nous adaptons nos logiciels aux besoins les plus spécifiques du client et nous offrons des solutions sur mesure."
            },
            val: {
                title: "Nos valeurs",
                desc: "- Innovation,<br/> - Satisfaction client, <br/> - Engagement, <br/> - Responsabilité."
            }
        },
         DashboardMockup:{
            ERP:"Moteur ERP",
            Active:"Surveillance active"
        }
    },
    en: {
        common: {
            en: "English",
            ar: "العربية",
            fr: "Français",
            home: "Home",
            about: "About",
            services: "Services",
            packs: "Packs",
            contact: "Contact",
            learnMore: "Learn More",
            send: "Send",
            sending: "Sending...",
            success: "Email sent successfully!",
            error: "Error sending email.",
            fillFields: "Please fill in all fields.",
            completeCaptcha: "Please complete the reCAPTCHA.",
            CRM:"24-CRM",
            Paie:"24-Paie",
            Gold:"24-Gold",
           
            
        },
        hero: {
            title: "Digitalize your business with confidence",
            subtitle: "Custom software solutions to optimize your business processes, developed by experts who understand your B2B challenges.",
            discover: "Discover our solutions",
            contactUs: "Contact us",
            trust: "Trusted by 2000+ companies across Africa",
            features: ["Custom Software", "Cloud Ready", "6/7 Support"]
        },
        expertise: {
            intro: "INTRODUCTION",
            aboutTitle: "ABOUT POLYSOFT&CO",
            description: "Tunisian company based in Sfax specializing in the development of IT solutions, part of the family group operating in the IT sector since 1988. We believe that each of our products must evolve and adapt to market needs to guarantee better customer satisfaction. Always concerned with guaranteeing the best, our efforts will never stop evolving thanks to a complete and tailor-made technical and commercial development process.",
            stats: {
                clients: "Our clients",
                experts: "Collaborators and business experts",
                experience: "Years of experience",
                solutions: "Solutions",
              
            } 
            , performance: "Performance that drives your growth",
            NOTRE:"OUR IMPACT",
            Ready: "Cloud Ready Solutions v2.4",
            ECOSYSTÈME :"POLYSOFT&CO Ecosystem"
        },
        services: {
            title: "OUR SERVICES",
            subtitle: "DISCOVER OUR SOLUTIONS",
            crm_desc: "Our new cloud platform for commercial management and sales representative management. Manage: Your stock, Your customers, Your suppliers, Your bank and your sales reps.",
            paie_desc: "24-Paie software offers much more than the essential payroll functions. Establish a complete payroll for your employees with software adaptable to all contracts.",
            gold_desc: "Management software for jewelry wholesale specialized for diamond dealers and goldsmiths.",
            dev_desc: "Custom development for your desktop, web and Mobile projects (Android, iOS) with the most modern technologies.",
            consulting_desc: "IT consulting and digital support for your companies towards digital transformation.",
            fasty_desc: "Synchronized E-commerce and Commercial Management site for an omnichannel experience.",
            pointage_desc: "PolyPointage is a solution for attendance management and time tracking, designed to automatically calculate worked hours, absences, tardiness, and leave. It also includes project-based attendance management and generates detailed reports to facilitate payroll preparation.",
            GenRS_desc: "This module allows the generation of withholding tax by automatically producing an XML file compliant with standards, ready for submission. It ensures that all necessary information is correctly formatted, facilitating secure and reliable transmission of tax data.",
            Gestion_Cloud: "Cloud Commercial Management",
            Gestion_Paie: "Human Resources and Payroll Management",
            Bijouterie: "Jewelry Store Management Software",
            Sur_Mesure: "Custom Software Development",
            Transformation: "Audit and Digital Transformation",
            GenRS: "Withholding Tax Generation (Independent / Synchronized)",
            fasty: "Synchronized E-commerce",
            Exploration:"Explore the Solution",
            PolyPointage:"Attendance and Time Tracking Software",
            more: "See more",
            less: "See less",
            CRM:"24-CRM",
            Paie:"24-Paie",
            Gold:"24-Gold",
           
                },
        packs: {
            title: "OUR OFFERS",
            subtitle: "OUR PACKS & MODULES",
            startup: "STARTUP PACK",
            growth: "GROWTH PACK",
            pro: "PRO PACK",
            commercial: "COMMERCIAL MODULE",
            desktop: "DESKTOP VERSION",
            web: "WEBSITE",
            features: {
                startup: [
                    "Single store version 1 user",
                    "Single store stock management",
                    "Customer management",
                    "Supplier management",
                    "Cash management"
                ],
                growth: [
                    "Multi-warehouse version 3 users",
                    "Multi-warehouse stock management",
                    "Transfer slips",
                    "Customer management",
                    "Supplier management",
                    "Cash management"
                ],
                pro: [
                    "Web/desktop synchronized version",
                    "Customer / Supplier management",
                    "Single / Multi-stock management",
                    "Inventory management",
                    "Cash management",
                    "Configurable modules by activity"
                ]
            }
        },
        contact: {
            title: "CONTACT US",
            subtitle: "Get in touch",
            tel_title: "Phone",
            address_title: "Address",
            address_val: "Rte de Teniour Km 1,5 / Sfax, Tunisia, 3000",
            form: {
                name: "Full Name",
                tel: "Phone",
                address: "Address",
                email: "Email",
                software: "Select a software",
                message: "Message",
                submit: "Send",
            },
            phone: "DIRECT LINE",
            support: "SUPPORT EMAIL",
            address: "HEAD OFFICE",
            tel:"+216 74 20 433 020",
        },
        aboutPage: {
            subtitle: "It's the ideal place",
            title: "About our company",
        },
        values: {
            intro: "Why choose us?",
            title: "OUR VALUES",
            vision: {
                title: "Our Vision",
                desc: "To be a leader in the local market, our ambitions go beyond borders, we aim to internationalize with targeted partners particularly in Africa."
            },
            mission: {
                title: "Our Mission",
                desc: "Our mission is to create high-performance and innovative management solutions for SMEs and support them in their digitalization process. We adapt our software to the client's specific needs and offer tailor-made solutions."
            },
            val: {
                title: "Our Values",
                desc: "- Innovation,<br/> - Customer Satisfaction, <br/> - Engagement, <br/> - Responsibility."
            }
        },
        DashboardMockup:{
            ERP:"ERP Engine",
            Active:"Active Monitoring"
        }
    },
    ar: {
        common: {
            en: "English",
            ar: "العربية",
            fr: "Français",
            home: "الرئيسية",
            about: "من نحن",
            services: "خدماتنا",
            packs: "عروضنا",
            contact: "اتصل بنا",
            learnMore: "اقرأ المزيد",
            send: "إرسال",
            sending: "جاري الإرسال...",
            success: "تم إرسال البريد بنجاح!",
            error: "خطأ في إرسال البريد.",
            fillFields: "يرجى ملء جميع الحقول.",
            completeCaptcha: "يرجى إكمال رمز التحقق.",
            CRM:"24CRM",
            Paie:"24Paie",
            Gold:"24Gold",
        },
        hero: {
            title: "رقمنة عملك بكل ثقة",
            subtitle: "نقدم حلولاً برمجية مخصصة مصممة بعناية لتحسين وتبسيط سير العمل داخل مؤسستك، تم تطويرها على يد خبراء يمتلكون فهماً عميقاً لتحديات ومتطلبات شركات B2B",
            discover: "اكتشف حلولنا",
            contactUs: "اتصل بنا",
            trust: "أكثر من 2000 عميل يضعون يثقون في POLYSOFT&CO",
            features: ["برمجيات مخصصة", "مصمم للسحاب", "دعم 6/7"]
        },
        expertise: {
            intro: "مقدمة",
            aboutTitle: "حول POLYSOFT&CO",
            description: "شركة تونسية مقرها صفاقس متخصصة في تطوير الحلول البرمجية، تتبع مجموعة عائلية تعمل في قطاع تكنولوجيا المعلومات منذ عام 1988. نؤمن بأن كل منتج من منتجاتنا يجب أن يتطور ويتكيف مع احتياجات السوق لضمان أفضل  من رضا العملاء. حرصاً منا دائماً على تقديم الأفضل، لن تتوقف جهودنا عن التطور بفضل عملية تطوير فنية وتجارية متكاملة ومخصصة.",
            stats: {
                clients: "عميل",
                experts: " فريق متعاون من الخبراء  ",
                experience: "سنة من الخبرة",
                solutions: "حلول برمجية",
              
            } , performance : " أداء يخدم نمو أعمالكم",
                NOTRE:"تأثيرنا",
                Ready: "حلول جاهزة للعمل على السحابة v2.4",
                ECOSYSTÈME :"  منظومة POLYSOFT&CO"
        },
      
        services: {
            title: "خدماتنا",
            subtitle: "اكتشف حلولنا",
            crm_desc: "منصتنا السحابية الجديدة لإدارة الأعمال التجارية ومندوبي المبيعات.تتيح إدارة المخزون والعملاء والموردين والحسابات البنكية والمندوبين",
            paie_desc: "يوفر برنامج 24-Paie أكثر بكثير من وظائف الرواتب الأساسية. قم بإنشاء كشف رواتب كامل لموظفيك مع برنامج يتكيف مع جميع العقود.",
            gold_desc: "برنامج إدارة تجارة الجملة للمجوهرات مخصص لتجار الألماس والصاغة.",
            dev_desc: "تطوير مخصص لمشاريع سطح المكتب والويب والجوال (أندرويد، iOS) وبأحدث التقنيات.",
            consulting_desc: "استشارات تقنية المعلومات والدعم الرقمي لشركاتكم نحو التحول الرقمي.",
            fasty_desc: "موقع تجارة إلكترونية وإدارة تجارية متزامن لتجربة متكاملة.",
            pointage_desc: "PolyPointage هو حل لإدارة الحضور وتتبع الوقت، مصمم لحساب ساعات العمل، الغياب، التأخير والإجازات تلقائيًا. كما يشمل إدارة الحضور حسب المشروع ويولّد تقارير مفصلة لتسهيل إعداد الرواتب.",
            GenRS_desc: "تتيح هذه الوحدة توليد ضريبة الاستقطاع من المصدر عن طريق إنشاء ملف XML تلقائيًا وفقًا للمعايير، جاهز للتقديم. كما تضمن تنسيق جميع المعلومات اللازمة بشكل صحيح، مما يسهل نقل البيانات الضريبية بأمان وموثوقية."
            , Gestion_Cloud:"الإدارة التجارية السحابية",
            Gestion_Paie:" إدارة الموارد البشرية والرواتب",
            Bijouterie:"برنامج إدارة محلات المجوهرات",
            Sur_Mesure:"تطوير برمجيات مخصّصة",
            Transformation:"التدقيق والتحول الرقمي",
            fasty:" التجارة الإلكترونية المتزامنة",
            GenRS:"توليد الخصم من المورد (مستقل / متزامن)",
            Exploration:"استكشاف الحل",
            PolyPointage:"نظام تسجيل الحضور وتتبع أوقات العمل",
            more: "عرض المزيد",
            less: "عرض أقل",
            CRM:"24CRM",
            Paie:"24Paie",
            Gold:"24Gold",
         
        },
        packs: {
            title: "عروضنا",
            subtitle: "الباقات والوحدات",
            startup: "باقة البداية",
            growth: "باقة النمو",
            pro: "الباقة الاحترافية",
            commercial: "وحدة المبيعات",
            desktop: "نسخة سطح المكتب",
            web: "موقع إلكتروني",
            features: {
                startup: [
                    "نسخة متجر واحد مستخدم واحد",
                    "إدارة مخزون متجر واحد",
                    "إدارة العملاء",
                    "إدارة الموردين",
                    "إدارة الخزينة"
                ],
                growth: [
                    "نسخة مستودعات متعددة 3 مستخدمين",
                    "إدارة مخزون مستودعات متعددة",
                    "قسائم التحويل",
                    "إدارة العملاء",
                    "إدارة الموردين",
                    "إدارة الخزينة"
                ],
                pro: [
                    "نسخة متزامنة ويب/سطح مكتب",
                    "إدارة العملاء والموردين",
                    "إدارة مخزون فردي/متعدد",
                    "إدارة المخزون",
                    "إدارة الخزينة",
                    "وحدات قابلة للتهيئة حسب النشاط"
                ]
            }
        },
        contact: {
            title: "اتصل بنا",
            subtitle: "ابق على تواصل",
            tel_title: "الهاتف",
            address_title: "العنوان",
            address_val: "طريق تنيور كم 1,5 / صفاقس، تونس، 3000",
            form: {
                name: "الاسم الكامل",
                tel: "الهاتف",
                address: "العنوان",
                email: "البريد الإلكتروني",
                software: "اختر برنامجاً",
                message: "الرسالة",
                submit: "إرسال",
            },
            phone: "الهاتف المباشر",
            support: "بريد الدعم",
            address: "المقر الرئيسي",
            tel:"+216 74 20 433 020",
           
        },
        aboutPage: {
            subtitle: "المكان المثالي",
            title: "حول شركتنا ",
        },
        values: {
            intro: "لماذا تختارنا؟",
            title: "قيمنا",
            vision: {
                title: "رؤيتنا",
                desc: "أن نكون رواد القطاع في السوق المحلية، وطموحاتنا تتجاوز الحدود،و نسعى الى التوسع دوليا بالشراكة مع شركاء استراتيجيين"
            },
            mission: {
                title: "مهمتنا",
                desc: "مهمتنا هي إنشاء حلول إدارة عالية الأداء ومبتكرة للشركات الصغيرة والمتوسطة ودعمهم في عملية الرقمنة. نقوم بتكييف برامجنا مع احتياجات العملاء الأكثر تحديداً ونقدم حلولاً مخصصة."
            },
            val: {
                title: "قيمنا",
                desc: "- الابتكار،<br/> - إرضاء العملاء، <br/> - الالتزام، <br/> - المسؤولية."
            }
        },
        DashboardMockup:{
            ERP:"محرك تخطيط موارد المؤسسة",
            Active:"المراقبة النشطة"
        }
    }
};
